import React, { FC, useState } from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';
import Container from '@mui/material/Container';
import Button from '@mui/material/IconButton';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import useMediaQuery from '@mui/material/useMediaQuery';

import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import useMainIsTop from 'src/hooks/useIsTop';

const Title = styled(Container)({
  paddingTop: 40,
  paddingBottom: 40,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const Content = styled(DialogContent)({
  backgroundColor: '#0d0d0d',
  // paddingLeft: 54,
  paddingTop: 108,
});

const ListWrapper = styled('ul')({
  listStyleType: 'none',
  padding: 0,
});

const ListItem = styled('li')({
  marginBottom: 32,
});

const Anchor = styled('a')({
  fontSize: 34,
  color: '#ffffff',
  textDecoration: 'none',
});

const StyledLink = styled(Link)({
  fontSize: 34,
  color: '#ffffff',
  textDecoration: 'none',
});

const Logo = styled('img')({
  width: 182,
  height: 42,
});
const Menu = styled('img')({
  width: 32,
  height: 32,
});
const MenuMobile: FC = () => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { isTop } = useMainIsTop();

  const shouldUseWhiteLogo = typeof window !== 'undefined' && isTop && window.location.pathname.length < 2;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          mobileMenuLink {
            name
            link
            external
          }
        }
      }
    }
  `);

  return (
    <>
      <IconButton aria-label="button" onClick={handleClickOpen}>
        <Menu
          src={shouldUseWhiteLogo ? '/icons/icListWhite.svg' : '/icons/icList.svg'}
          alt="menu button"
        />
      </IconButton>
      <Dialog
        sx={{ maxWidth: '100vw', overflowX: 'hidden' }}
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="mobile-menu"
      >
        <Title>
          <Logo src="/logos/img-header-logo.svg" alt="hyperconnect career" />
          <Button onClick={handleClose}>
            <CloseIcon />
          </Button>
        </Title>
        <Content>
          <Container>
            <ListWrapper>
              {data.site.siteMetadata.mobileMenuLink.map(item => {
                if (item.external) {
                  return (
                    <ListItem key={item.link}>
                      <Anchor href={item.link} target="_blank" rel="noreferrer">
                        {item.name}
                      </Anchor>
                    </ListItem>
                  );
                }
                return (
                  <ListItem key={item.link}>
                    <StyledLink to={item.link}>{item.name}</StyledLink>
                  </ListItem>
                );
              })}
            </ListWrapper>
          </Container>
        </Content>
      </Dialog>
    </>
  );
};

export default MenuMobile;
